import React, {useContext} from "react";
import {FiTrash2} from "react-icons/fi";
import {TabInput} from "../../../../components";
import {FOOT, INCH, METER, UnitContext} from "../../../../contexts/UnitContext";
import {Alert} from "antd";
import {useViewerStore} from "../../../../store/store";
import {
    SetLineSnap
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/LineControl";
import SliderInput from "../../../../components/Pure-UI-Components/SliderInput/SliderInput";

const MeasureOptions = () => {
    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const snappingDistanceForTapeMeasure = useViewerStore(state => state.snappingDistanceForTapeMeasure);

    const resetDraw = () => {
        sceneViewer.resetDraw(false);
    }

    const {unit, renderUnit} = useContext(UnitContext);

    let settingsDisSnap;
    switch (unit) {
        case INCH:
            settingsDisSnap = {min: 12, max: 100, step: 1,};
            break;
        case FOOT:
            settingsDisSnap = {min: 1, max: 9, step: 0.1,};
            break;
        case METER:
            settingsDisSnap = {min: 0.3, max: 3, step: 0.01,};
            break;
    }

    const onSnapDistanceChange = (value: number) => {
        const meterValue = value * 0.3048
        useViewerStore.setState({snappingDistanceForTapeMeasure: value});
        sceneViewer.setLineSnapDis(meterValue);
    }

    return (
        <div className="tab__inner">
            <div className="tab__title">
                <span className="tab__title--text">Measure</span>
                <div className="tab__title--btns">
                    <FiTrash2 onClick={resetDraw}/>
                </div>
            </div>

            <div className='tab__column'>
                <div className='tab__flex justify-between mb-2'>
                    <span className='tab__column--subtitle mb-0'>Snapping</span>
                    <button className={`toggler`} onClick={() => {
                        SetLineSnap(sceneViewer, !sceneViewer.flagLineSnap);
                    }} id={`switchLineSnapping`}></button>
                </div>
                <div id="rangeLineSnap" className="">
                    <span className="tab__column--subtitle">Snap distance</span>
                    <SliderInput
                        value={snappingDistanceForTapeMeasure} onChange={onSnapDistanceChange}
                        settings={settingsDisSnap}
                    />

                </div>
                <br/>
                <Alert
                    style={{ color: "black" }}
                    message="Toggle this ON to snap the pointer the edges" type="info" showIcon/>
            </div>

            <div className="tab__column">
                <span className="tab__column--title">Length</span>
                <div className="tab__flex justify-between">
                    <TabInput unit={renderUnit(unit)} readOnly={true} variant='input-lg' value='45.90'
                                property='MeasureLineLength' className='min-none'/>
                </div>
            </div>

            <div className="tab__column">
                <span className="tab__column--title">Area</span>
                <div className="tab__flex justify-between">
                    <TabInput unit={renderUnit(unit)} readOnly={true} variant='input-lg' value='45.90'
                                property='MeasureAreaSize' className='min-none'/>
                </div>
            </div>
        </div>
    );
};

export default MeasureOptions;
